import React from "react";
import { useHistory } from "react-router-dom";

export default function BackLink({ onBack, className = "" }) {
  const history = useHistory();
  const handleClick = () => {
    if (onBack) onBack();
    else history.push("/dashboard/main");
  };
  return (
    <div className={`overview-back ${className}`}>
      <button
        type="button"
        className="overview-back__link"
        onClick={handleClick}
      >
        <span aria-hidden="true" className="overview-back__icon">
          &lt;
        </span>
        Return to homepage
      </button>
    </div>
  );
}
